export const RECEIVE_AVAILABILITIES = 'RECEIVE_AVAILABILITIES';
export const GET_AVAILABILITIES = 'GET_AVAILABILITIES';
export const SET_AVAILABILITY = 'SET_AVAILABILITY';
export const UPDATE_AVAILABILITY = 'UPDATE_AVAILABILITY';
export const DELETE_AVAILABILITY = 'DELETE_AVAILABILITY';
export const FETCH_AVAILABILITIES = 'FETCH_AVAILABILITIES';
